const eventSelectors = {
  buttons: '[data-event-space-trigger]',
  card: '.event-space',
  cardContents: '.event-space-overlay',
  closeButton: '.event-space-close',
};

const homepageSelectors = {
  scrollToAnchor: '[data-scroll-to]',
};

const activateEventCard = function(button) {
  let eventCard = button.closest(eventSelectors.card);
  let eventCardContents = eventCard.querySelector(eventSelectors.cardContents);
  let closeButton = eventCard.querySelector(eventSelectors.closeButton);

  if (eventCard) {
    eventCard.classList.add('is-flipped');
    closeButton.addEventListener('click', handleCardClose, false);

    // ARIA
    eventCardContents.setAttribute('aria-hidden', 'false');
    button.setAttribute('aria-expanded', 'true');
    button.setAttribute('tabindex', '-1');
    closeButton.setAttribute('tabindex', '0');
  }
};

let handleCardClose = function() {
  let closeButton = event.target.closest(eventSelectors.closeButton);
  let eventCard = closeButton.closest(eventSelectors.card);
  let openButton = eventCard.querySelector(eventSelectors.buttons);
  let eventCardContents = eventCard.querySelector(eventSelectors.cardContents);

  if (eventCard) {
    eventCard.classList.remove('is-flipped');
    closeButton.removeEventListener('click', handleCardClose, false);

    // ARIA
    eventCardContents.setAttribute('aria-hidden', 'true');

    setTimeout(function() {
      eventCardContents.focus();
    }, 1000);
    openButton.setAttribute('aria-expanded', 'false');
    openButton.setAttribute('tabindex', '0');
    closeButton.setAttribute('tabindex', '-1');
  }
};

let scrollToElement = function(target) {
  if (!target) {
    return;
  }

  const scrollPos = target.offsetTop - (document.getElementById('top-bar-menu').offsetHeight);
  window.scrollTo(0, scrollPos);
};

// jQuery(document).ready(function() {
document.addEventListener('DOMContentLoaded', () => {
  const eventDetailBtns = document.querySelectorAll(eventSelectors.buttons);
  const scrollToAnchor = document.querySelectorAll(homepageSelectors.scrollToAnchor);
  const pageHeader = document.querySelector('.header');
  const offCanvas = document.querySelector('.off-canvas');

  if (eventDetailBtns.length > 0) {
    for (var i = 0; i < eventDetailBtns.length; i++) {
      eventDetailBtns[i].addEventListener('click', function(event) {
        activateEventCard(event.target);
      });
    }
  }

  if (scrollToAnchor.length > 0) {
    for (let n = 0; n < scrollToAnchor.length; n++) {
      scrollToAnchor[i].addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        const targetSelector = event.target.getAttribute('data-scroll-to');
        const scrollTarget = document.querySelector(targetSelector);
        scrollToElement(scrollTarget);
      });
    }
  }

  if (pageHeader && offCanvas) {
    const newOffCanvasPadding = pageHeader.offsetHeight + 50;
    offCanvas.style.paddingTop = `${newOffCanvasPadding}px`;
  }

});

const splashClose = document.querySelector('[data-splash-close]');

if (splashClose) {
  document.body.classList.add('scroll-locked');

  splashClose.addEventListener('click', (event) => {
    event.preventDefault();

    const splash = splashClose.closest('[data-splash-page]');

    splash.classList.add('hide');
    splash.remove();
    updateSplashUrl();
  });
}

// Update the URL in the address bar
function updateSplashUrl() {
  const currentURL = document.location;
  const currentURLString = currentURL.toString();
  let newURL = currentURL;

  if (currentURL.href.includes('/?')) {
    newURL = `${currentURLString}&nosplash=1`;
  } else {
    newURL = `${currentURLString}?nosplash=1`;
  }

  history.pushState({
    id: 'nosplash'
  }, null, newURL);
}
